import { render, staticRenderFns } from "./AccountTreeIcon.vue?vue&type=template&id=ccdc5cb6&scoped=true&"
import script from "./AccountTreeIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AccountTreeIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdc5cb6",
  null
  
)

export default component.exports